import PropTypes from "prop-types";
import { Text } from "@shopify/polaris";
import styled from "@emotion/styled";

const ClampedText = styled(Text)(({ lines = 2 }) => ({
  display: "-webkit-box",
  WebkitLineClamp: lines,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

ClampedText.propTypes = {
  lines: PropTypes.number,
};

export default ClampedText;
